module.exports = __webpack_public_path__ + "img/house_img1.f3d00961.png";